(function($) {
	formHelper.addRule({
		form: '.form-manage-premium-membership-discount',
		status: {
			SUCCESS: function() {
				this.redirect(this.data.redirectTo);
			},
			ERROR: function() {
				if (this.data) {
					if (this.data.systemMessage1) {
						$('#system-message-1').html(this.data.systemMessage1);
					}
					if (this.data.systemMessage2) {
						$('#system-message-2').html(this.data.systemMessage2);
					}
					if (this.data.systemMessage3) {
						$('#system-message-3').html(this.data.systemMessage3);
					}
				}
			}
		}
	});
})(jQuery);

jQuery(function initToolsPremiumDiscounts($) {
	$('.manage-premium-membership-discount-form').each(function(index, el) {

		var $container = $(this);

		$container.find($('.tools-toggle-icon')).each(function(el) {
			$(this).click(function(event) {
				$(this).toggleClass('toggle-closed');
				$(this).closest('.membership-type-container').find('.membership-type-sub-container').toggle();
			});
		});
	});
});